<template>
  <v-container fluid style="background-color: white">
    <v-row class="mb-4">
      <v-col>
        <v-btn class="bg-gradient-success mr-4" dark @click="_sendRequest"
          >Баталгаажуулаx xүсэлт</v-btn
        >
        <v-btn class="bg-gradient-info mr-4" dark @click="_saveToESIS"
          >Xадгалаx</v-btn
        >
      </v-col>
      <v-col class="text-end">
        <v-btn class="mr-4 red--text" outlined @click="_printBmayagt"
          >Бүртгэлийн маягт</v-btn
        >
      </v-col>
    </v-row>
    <v-data-table
      v-if="$attrs.classStudents"
      :headers="headers"
      :items="$attrs.classStudents"
      class="elevation-1"
      hide-details
      hide-default-footer
      :items-per-page="-1"
    >
      <template slot="item" slot-scope="props">
        <tr>
          <td style="width: 2%">{{ props.index + 1 }}</td>
          <td>
            {{ props.item.name }} /<span class="blue--text">{{
              props.item.REGISTER
            }}</span
            >/
          </td>
          <td>
            <v-text-field
              v-model="props.item.decision_number"
              dense
              hide-details
            />
          </td>
          <td>
            <v-select
              :items="decisionOptions"
              v-model="props.item.decision"
              label="Шийдвэр сонгоx"
            />
          </td>
          <td v-if="props.item.graduatedAt">{{ props.item.graduatedAt }}</td>
          <td v-else></td>
          <td v-if="props.item.actionCode">
            <v-chip color="blue lighten-4" text-color="blue darken-2">
              {{ props.item.actionCode }}
            </v-chip>
          </td>
          <td v-else>
            <v-btn
              outlined
              small
              class="blue--text"
              v-if="!props.item.savedToESISAt"
              >Дүүргэсэн</v-btn
            >
          </td>
          <td>
            <v-btn
              @click="_deleteFromESIS(props.item)"
              icon
              small
              class="red--text"
              v-if="!props.item.savedToESISAt"
            >
              <v-icon>mdi-delete</v-icon></v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import axios from "axios";
import XLSX from "xlsx";
export default {
  data() {
    return {
      selectedNextClassGroup: null,
      headers: [
        { text: "№", value: "index" },
        { text: "Суралцагч", value: "name" },
        { text: "Шийдвэрийн №", value: "decision_number" },
        { text: "Шийдвэр", value: "decision" },
        { text: "Үйлдлийн огноо", value: "date" },
        { text: "Төлөв", value: "actionCode" },
        { text: "Үйлдэл", value: "action" },
      ],
      decisionOptions: ["Төгсгөx", "Суралцуулаx"],
      decisionReasons: [
        {
          action_id: 1001,
          action: "Дэвшин суралцах",
          action_Reason_id: 78,
          reasonName: "Суралцах түвшин амжилттай дүүргэсэн",
          actionCode: "PROGRESSION",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 48,
          reasonName: "Эрүүл мэндийн шалтгаанаар",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 62,
          reasonName: "Гэмт хэрэгт холбогдсон",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 80,
          reasonName: "Амьдралын шаардлагаар",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 110,
          reasonName: "Сурлагын амжилт хангалтгүй",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 111,
          reasonName: "Хичээл дутуу судалсан",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 112,
          reasonName: "Шалгалт өгөөгүй(Төгсөх эсвэл дэвших)",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 113,
          reasonName: "Ирэхээ больсон",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 128,
          reasonName: "Нас хүрээгүй шалтгаанаар",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1002,
          action: "Давтан суралцах",
          action_Reason_id: 130,
          reasonName: "Эцэг, эхийн хүсэлтээр",
          actionCode: "ATTEMPT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 2,
          reasonName: "Цэргийн жинхэнэ албанд татагдсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 16,
          reasonName: "Мэдээллийг буруу оруулсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 48,
          reasonName: "Эрүүл мэндийн шалтгаанаар",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 61,
          reasonName: "Нас барсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 62,
          reasonName: "Гэмт хэрэгт холбогдсон",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 63,
          reasonName: "Ажил эрхлэхээр",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 64,
          reasonName: "Сургалтын төлбөр төлөөгүй",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 65,
          reasonName: "Сургалтын байгууллагын шийдвэрээр",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 67,
          reasonName: "Сурах дургүйгээс",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 70,
          reasonName: "Ар гэрийн гачигдал",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 75,
          reasonName: "Шилжиж явсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 77,
          reasonName: "Сахилгын арга хэмжээ авсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 80,
          reasonName: "Амьдралын шаардлагаар",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 97,
          reasonName: "Сураггүй болсон",
          actionCode: "EXIT",
        },
        {
          action_id: 1006,
          action: "Дэвшин сурахаар гарах",
          action_Reason_id: 99,
          reasonName: "Бусад улс руу шилжиж явсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 2,
          reasonName: "Цэргийн жинхэнэ албанд татагдсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 16,
          reasonName: "Мэдээллийг буруу оруулсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 48,
          reasonName: "Эрүүл мэндийн шалтгаанаар",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 61,
          reasonName: "Нас барсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 62,
          reasonName: "Гэмт хэрэгт холбогдсон",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 63,
          reasonName: "Ажил эрхлэхээр",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 64,
          reasonName: "Сургалтын төлбөр төлөөгүй",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 65,
          reasonName: "Сургалтын байгууллагын шийдвэрээр",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 67,
          reasonName: "Сурах дургүйгээс",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 70,
          reasonName: "Ар гэрийн гачигдал",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 75,
          reasonName: "Шилжиж явсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 77,
          reasonName: "Сахилгын арга хэмжээ авсан",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 80,
          reasonName: "Амьдралын шаардлагаар",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 97,
          reasonName: "Сураггүй болсон",
          actionCode: "EXIT",
        },
        {
          action_id: 1007,
          action: "Давтан сурахаар гарах",
          action_Reason_id: 99,
          reasonName: "Бусад улс руу шилжиж явсан",
          actionCode: "EXIT",
        },
      ],
    };
  },
  created() {
    console.log(this.$attrs.tokenData.token);
  },
  methods: {
    _printBmayagt() {
      const wb = XLSX.utils.book_new();
      this.excelLoading = true;
      var excelData = [];

      this.$attrs.classStudents.forEach((stud, sindex) => {
        var row = {};
        row["No"] = sindex + 1;

        row["Овог"] = stud.LAST_NAME;
        row["Нэр"] = stud.FIRST_NAME;
        row["Регистр"] = stud.REGISTER;
        row["Бүрэн дунд боловсролын үнэмлэxний дугаар"] = stud.REGISTER;
        row["Сурлагын үнэлгээний дундаж"] = 0;
        
        excelData.push(row);
      });
      const data = XLSX.utils.json_to_sheet(excelData);
      XLSX.utils.book_append_sheet(wb, data, "b-mayagt");
      XLSX.writeFile(
        wb,
        "school-" +
          this.$attrs.currentClassGroup.STUDENT_GROUP_NAME +
          "b-mayagt.xlsx"
      );
    },
    async _deleteFromESIS(item) {
      console.log(item, item.PERSON_ID);
      var urlLink =
        this.$store.state.domainESISAddress +
        "/svc/api/hub/student/progression/delete";
      console.log("writing to...", urlLink);
      var bodyData = {
        studentGroupId: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
        personId: item.PERSON_ID,
      };
      console.log(this.$attrs.tokenData.token);
      await this.writeToESIS(urlLink, bodyData);
    },
    async _sendRequest() {
      // this.$swal.fire("Success", "Request sent successfully", "success");
      // this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
      var urlLink =
        this.$store.state.domainESISAddress +
        "/svc/api/hub/stdnt/progression/request";
      console.log("writing to...", urlLink);
      var bodyData = {
        inStudentGroupID: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
      };
      this.writeToESIS(urlLink, bodyData);
    },
    async _saveToESIS() {
      // this.$swal.fire("Success", "Data saved successfully", "success");
      // this.$swal.fire("Xугацаа нь болxоор нээгдэнэ!");
      var inStudentList = [];
      // var counter = 0;
      for (const stud of this.$attrs.classStudents) {
        console.log(
          stud.FIRST_NAME,
          stud.decision_number,
          stud.decision,
          stud.reason
        );
        if (stud.decision_number) {
          // counter++;
          inStudentList.push({
            person_id: Number(stud.PERSON_ID),
            // student_group_id: stud.nextClassGroup.STUDENT_GROUP_ID,
            student_group_id: 100004996820150,
            decision_number: stud.decision_number,
            action_id: stud.reason.action_id,
            action_Reason_id: stud.reason.action_Reason_id,
          });
        }

        // if (counter == 1)
        //   console.log({
        //     person_id: Number(stud.PERSON_ID),
        //     // student_group_id: stud.nextClassGroup.STUDENT_GROUP_ID,
        //     decision_number: stud.decision_number,
        //     action_id: stud.reason.action_id,
        //     action_Reason_id: stud.reason.action_Reason_id,
        //   });

        var urlLink =
          this.$store.state.domainESISAddress +
          "/svc/api/hub/stdnt/progression/save";

        console.log("writing to...", urlLink);

        var bodyData = {
          inStudentGroupID: this.$attrs.selectedClassGroup.STUDENT_GROUP_ID,
          inStudentList: inStudentList,
        };

        await this.writeToESIS(urlLink, bodyData);
        //if successfull update firebase
        var batch = fb.db.batch();
        for (var student of this.$attrs.classStudents) {
          batch.update(student.ref, {
            devshiltDecisionNumber: student.decision_number,
            devshiltDecision: student.decision,
            devshiltReason: student.reason,
            nextClassGroupId: student.nextClassGroup
              ? student.nextClassGroup
              : null,
            savedAt: new Date(),
            savedToESISAt: new Date(),
            savedToESIS: true,
          });
        }
      }
      //selectedNextClassGroup
    },
    timeDifference(startTime, endTime) {
      const start = new Date(startTime);
      const end = new Date(endTime);
      const diffMs = end - start;

      // const hours = Math.floor(diffMs / (1000 * 60 * 60));
      const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

      return `${minutes}m ${seconds}s`;
    },
    async writeToESIS(urlLink, bodyData) {
      var startTime = new Date();
      await axios
        .post(
          "https://us-central1-digitalschool-3f1e9.cloudfunctions.net/esisWrite",
          {
            url: urlLink,
            token: this.$attrs.tokenData.token,
            data: bodyData,
          }
        )
        .then((res) => {
          this.loading = false;
          var diff = this.timeDifference(startTime, new Date());
          console.log(
            "RESPONSE from ESIS",
            res,
            res.status == 200,
            res.data.SUCCESS_CODE
          );
          this.saveESISresponse = res;
          this.$swal.fire({
            title: res.data.RESPONSE_MESSAGE,
            text: res.data.RESULT + "<p>" + diff + "</p>",
          });
          // this.showSaveESISResponseDialog = !this.showSaveESISResponseDialog;
        })
        .catch((error) => {
          console.log(this.$attrs.tokenData.token);
          console.log(bodyData);
          console.error("Error:", error);
          this.$swal.fire({
            title: error.code,
            text: error.response.data,
            icon: "error",
          });
          //errorhandling write to firebase
        });
    },
  },
};
</script>
<!-- if saved successfull then, saved to firebase etwas -->